import React, { Component, Fragment } from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions } from "store";
import { DomainList, DomainForm } from 'components/blocks/Domain';


class DomainListScreen extends Component {
  showForm = (item = null) => {
    const { actions } = this.props;
    actions.domainShowEditForm({ show: true, object: item });
  };

  render() {
    const { site, history } = this.props;
    const detail = site.detail;

    return (
      <Fragment>
        <div className="page-content page-content-full">
          <div className="page-block page-block-full">
            {detail &&
            <DomainList
              history={history}
              activeFilter={{ id: detail.domain.id }}
              topActions={[
                <Button type="primary" className="" icon="plus" onClick={() => this.showForm()}>
                  Добавить домен
                </Button>
              ]}
            />}
          </div>
        </div>

        {detail &&
        <DomainForm parentId={detail.domain.id}/>}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.domain), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DomainListScreen);
